/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigurationResponse } from '../../models/configuration-response';

export interface GetOptsConfigurations$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
}

export function getOptsConfigurations(http: HttpClient, rootUrl: string, params: GetOptsConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, getOptsConfigurations.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfigurationResponse>;
    })
  );
}

getOptsConfigurations.PATH = '/stores/{storeId}/preptimes';
